// Modules
import React, { useCallback } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

import { Page, PageHeader, PageContent } from 'components/page';
import { Table } from 'components/content-containers/tables';
import { showDeleteModal } from 'modules/modals/actions';
import { alerts } from 'modules/alerts/actions';
import MfaDevice from 'services/data/mfa-device';
import {
  EditButton,
  DeleteButton
} from 'components/widgets/buttons';
import { PrimaryButton } from '../../components/widgets/buttons/buttons';

import { useMfaDevicesWithConnections } from './hooks/use-mfa-devices';


// Component
export default function MfaDevices() {
  const { data: devices = [], isLoading, refetch } = useMfaDevicesWithConnections();

  const deleteDevice = useCallback((device) => {
    showDeleteModal({
      title: 'Delete MFA Device',
      body: <p>Are you sure you want to delete <strong>{device.name}</strong>?</p>,
      onConfirm: () => {
        MfaDevice.update({ id: device.id, status: 'Archived' })
          .then(() => refetch())
          .catch(alerts.catchError);
      }
    });
  }, [refetch]);

  const headerActions = (
    <div className="header-actions">
      <Link to="/mfa/add">
        <PrimaryButton>Add Device</PrimaryButton>
      </Link>
    </div>
  );

  return (
    <Page>
      <PageHeader title="MFA Devices" actions={headerActions} />
      <PageContent
        fetching={isLoading}
        emptyText="No MFA devices configured."
        emptyTextIcon="svg/cog.svg"
        showEmptyText={!isLoading && _.isEmpty(devices)}
      >
        <Table>
          <thead>
            <tr>
              <th className="collapse-width no-wrap">Team</th>
              <th className="collapse-width no-wrap">Name</th>
              <th className="collapse-width no-wrap">Description</th>
              <th>In Use</th>
              <th></th>
              <th className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {_.map(devices, (device) => (
              <tr key={device.id}>
                <td className="no-wrap text-center">
                    <span className="color-dot" style={{ backgroundColor: device.team?.color }}></span>
                </td>
                <td className="no-wrap">
                  <Link to={`/mfa/${device.id}/connect`}>
                    {device.name}
                  </Link>
                </td>
                <td className="no-wrap">{device.description}</td>
                <td style={{ whiteSpace: 'normal' }}>
                  {device.connectedUsers?.length > 0 && device.connectedUsers.join(', ')}
                </td>
                <td></td>
                <td className="text-right options-cell pr-0">
                  <Link to={`/mfa/${device.id}/edit`}>
                    <EditButton />
                  </Link>
                  <DeleteButton onClick={() => deleteDevice(device)} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </PageContent>
    </Page>
  );
}
